import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Parkings (enrobés & asphalte)", href: "/services/parkings" },
  { label: "Terrasses", href: "/services/terrasses" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function DallesCarrossablesPage() {
  return (
    <ServicePageLayout
      tag="Surfaces lourdes"
      title="Dalles carrossables"
      subtitle="Protection et étanchéité de dalles soumises au trafic lourd : résines haute résistance, asphalte coulé, membranes spécifiques."
      heroImage="https://readdy.ai/api/search-image?query=wide%20concrete%20carrossable%20slab%20with%20freshly%20applied%20thick%20protective%20waterproof%20coating%2C%20heavy%20duty%20surface%20treatment%2C%20construction%20site%20with%20machinery%2C%20dramatic%20perspective%2C%20professional%20BTP%20photography%2C%20strong%20industrial%20aesthetic%2C%20wide%20angle&width=1440&height=900&seq=ksbtp-dalle-hero-001&orientation=landscape"
      heroAlt="Étanchéité dalles carrossables KS BTP"
      intro="Les dalles carrossables sont soumises à des contraintes mécaniques et hydriques extrêmes. KS BTP propose des systèmes d'étanchéité haute performance adaptés au trafic lourd : asphalte coulé, résines polyuréthane ou époxy, membranes bitumineuses renforcées. Nous intervenons sur les dalles de toiture-parking, les voiries sur dalle, les quais de chargement et toutes surfaces soumises à des charges importantes."
      techItems={[
        { icon: "ri-truck-line", label: "Asphalte coulé trafic lourd" },
        { icon: "ri-shield-fill", label: "Résines polyuréthane" },
        { icon: "ri-stack-line", label: "Membranes renforcées" },
        { icon: "ri-building-4-line", label: "Voiries sur dalle" },
        { icon: "ri-arrow-up-down-line", label: "Quais de chargement" },
        { icon: "ri-tools-fill", label: "Réfection & renforcement" },
      ]}
      steps={[
        {
          number: "01",
          title: "Analyse structurelle",
          description: "Évaluation des charges, de l'état du béton et des contraintes spécifiques au trafic prévu.",
        },
        {
          number: "02",
          title: "Préparation du support",
          description: "Grenaillage, traitement des fissures et des joints, application d'une primaire d'accrochage.",
        },
        {
          number: "03",
          title: "Mise en œuvre",
          description: "Application du système d'étanchéité haute résistance adapté aux charges et au trafic.",
        },
        {
          number: "04",
          title: "Contrôle & livraison",
          description: "Tests de résistance, vérification de l'étanchéité et remise des documents de garantie.",
        },
      ]}
      advantages={[
        "Systèmes conçus pour résister aux charges lourdes et au trafic intense",
        "Matériaux haute performance : asphalte coulé, résines, membranes renforcées",
        "Traitement des points singuliers : joints, relevés, siphons",
        "Intervention en milieu contraint ou en site occupé",
        "Conformité aux normes DTU et aux exigences structurelles",
        "Garantie décennale sur l'ensemble des travaux réalisés",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=heavy%20duty%20concrete%20slab%20with%20thick%20asphalte%20coule%20waterproofing%20layer%20being%20applied%20by%20professional%20workers%2C%20industrial%20construction%20site%2C%20machinery%2C%20dramatic%20wide%20angle%20view&width=600&height=440&seq=ksbtp-dalle-gal-001&orientation=landscape",
          alt: "Application asphalte coulé dalle",
        },
        {
          src: "https://readdy.ai/api/search-image?query=finished%20carrossable%20slab%20with%20smooth%20dark%20protective%20coating%2C%20truck%20driving%20on%20surface%2C%20industrial%20facility%2C%20professional%20construction%20photography%2C%20strong%20perspective&width=600&height=440&seq=ksbtp-dalle-gal-002&orientation=landscape",
          alt: "Dalle carrossable terminée",
        },
        {
          src: "https://readdy.ai/api/search-image?query=close%20up%20of%20polyurethane%20resin%20being%20applied%20on%20concrete%20surface%2C%20professional%20worker%20with%20roller%2C%20smooth%20grey%20coating%2C%20construction%20site%2C%20sharp%20detail%20photography&width=600&height=440&seq=ksbtp-dalle-gal-003&orientation=landscape",
          alt: "Application résine polyuréthane",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
